export default {
  "config": {
    "trial": "driving",
    "id": "sdlp-analysis",
    "type": "table",
    "title": "Analysis of SDLP  Favored Solriamfetol vs Placebo at 2 h and 6 h Time Points<sup>29</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
      "<sup>a</sup>For participants who did not complete the driving test, data for the part of the drive that was completed was used to calculate SDLP.",
      "<no-break><sup>b</sup>Solriamfetol – placebo.</no-break>",
      "<sup>c</sup>Repeated mixed-effects analysis of variance.",
      "<sup>d</sup>Primary endpoint. At 2 h post-dose, the driving test was stopped early for 4 participants receiving placebo (2 tests stopped by participant, 2 tests stopped by instructor) and 1 participant receiving solriamfetol (test stopped by participant).",
      "<sup>e</sup>At 6 h post-dose, the driving test was stopped early for 7 participants receiving placebo (5 tests stopped by participant, 2 tests stopped by instructor) and 3 participants receiving solriamfetol (all tests stopped by participant)."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "driving",
    "id": "sdlp-analysis",
    "data-type": "table",
    "title": "Analysis of SDLP  Favored Solriamfetol vs Placebo at 2 h and 6 h Time Points<sup>29</sup>",
    "num-header-rows": 3,
    "num-columns": 7,
    "col-classes": [
      "col-1",
      "pbo",
      "pbo",
      "sol",
      "sol",
      "diff",
      "pvalue"
    ],
    "row-mergeoption": [
      1,
      2,
      3
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a",
      "footnote-b",
      "footnote-c",
      "footnote-d",
      "footnote-e"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
    "footnote-a": "<sup>a</sup>For participants who did not complete the driving test, data for the part of the drive that was completed was used to calculate SDLP.",
    "footnote-b": "<no-break><sup>b</sup>Solriamfetol – placebo.</no-break>",
    "footnote-c": "<sup>c</sup>Repeated mixed-effects analysis of variance.",
    "footnote-d": "<sup>d</sup>Primary endpoint. At 2 h post-dose, the driving test was stopped early for 4 participants receiving placebo (2 tests stopped by participant, 2 tests stopped by instructor) and 1 participant receiving solriamfetol (test stopped by participant).",
    "footnote-e": "<sup>e</sup>At 6 h post-dose, the driving test was stopped early for 7 participants receiving placebo (5 tests stopped by participant, 2 tests stopped by instructor) and 3 participants receiving solriamfetol (all tests stopped by participant).",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Standard deviation of lateral position</b></center>",
          "cols": 5,
          "class": "pbo"
        },
        {
          "content": null,
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-1": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Placebo</b></center>",
          "cols": 2,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b>Solriamfetol</b></center>",
          "cols": 2,
          "class": "sol"
        },
        {
          "content": null,
          "cols": 2,
          "class": "diff"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "<b>Time point<sup>a</sup></b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>n</b></center>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b><no-break>LS mean (SE),</no-break> cm</b></center>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b>n</b></center>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<center><b><no-break>LS mean (SE),</no-break> cm</b></center>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<center><b><no-break>LS mean difference<sup>b</sup></no-break> <no-break>(95% CI), cm</no-break></b></center>",
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "<b><em>P</em> value<sup>c</sup></b>",
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "2 hours post-dose<sup>d</sup>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "33",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "19.9 (0.63)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "34",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "18.8 (0.63)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>–1.1</b> <no-break>(–1.85, –0.32)</no-break>",
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.006",
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "6 hours post-dose<sup>e</sup>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "32",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "20.0 (0.63)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "32",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "19.2 (0.63)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>–0.8</b> <no-break>(–1.58, –0.03)</no-break>",
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.043",
          "cols": 1,
          "class": "pvalue"
        }
      ]
    }
  }
};